import * as React from 'react';
import * as _ from 'lodash';
import { InstallationGroupItemsCard } from './InstallationGroupItemsCard';
import { NewInstallationGroupItem } from './NewInstallationGroupItem';
import { cleanProps } from '../../../utilities/props';
export default function () {
    function repeatInstallation1(installation, installationIndex) {
        return [React.createElement(InstallationGroupItemsCard, {
                'key': installation.id,
                'installation': installation,
                'groupName': this.props.group,
                'installationGroup': this.props.installationGroup
            })];
    }
    function repeatInstallation2(installation, installationIndex) {
        return [React.createElement(InstallationGroupItemsCard, {
                'key': installation.id,
                'installation': installation,
                'groupName': this.props.group,
                'installationGroup': this.props.installationGroup
            })];
    }
    return React.createElement('div', _.assign({}, cleanProps(this.props)), React.createElement.apply(this, [
        'div',
        { 'className': 'lightbox-flex-container' },
        React.createElement(NewInstallationGroupItem, { 'installationGroup': this.props.activeInstallationGroup }),
        _.map(this.props.enabledInstallations, repeatInstallation1.bind(this)),
        React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
        React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
        React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
        React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
        React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
        React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
        React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
        this.props.disabledInstallations.length > 0 ? React.createElement.apply(this, [
            'div',
            {
                'className': 'lightbox-flex-disabled-container',
                'key': '2127'
            },
            React.createElement('h1', {}, 'Disabled Installations'),
            _.map(this.props.disabledInstallations, repeatInstallation2.bind(this)),
            React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
            React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
            React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
            React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
            React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
            React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' }),
            React.createElement('div', { 'className': 'lightbox-flex-item lightbox-flex-dummy-item' })
        ]) : null
    ]));
}